import React from 'react';
import { useTranslation } from 'react-i18next';
import { ManageProductReservations } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';

export function ManageProductReservationsPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('manage-product-reservations-component.metatags.title'),
        description: t('manage-product-reservations-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.manageProductReservations,
        index: false,
    });

    return (
        <FiltersProvider>
            <ManageProductReservations />
        </FiltersProvider>
    );
}
